import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c('div',{staticClass:"wrapper"},[_c('router-view'),(_vm.isPreloaderVisible)?_c('Preloader',{attrs:{"title":"Otimizando","subtitle":"Estamos otimizando a interface do NewsHub para você, aguarde alguns instantes :)"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }